
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var iconSizes = {
  sm: 28,
  md: 30,
  lg: 32
};
var spinnerWrapperVariants = {
  hidden: {
    opacity: 0,
    marginInlineEnd: 6,
    transition: {
      duration: 0.1
    }
  },
  visible: {
    opacity: 1,
    marginInlineEnd: 6,
    transition: {
      duration: 0.1
    }
  }
};

export { iconSizes, spinnerWrapperVariants };
//# sourceMappingURL=constants.js.map
